import CloseIcon from '@mui/icons-material/Close';
import PlayArrow from '@mui/icons-material/PlayArrow';
import {
  Avatar,
  Box,
  Chip,
  Collapse,
  Dialog,
  Grid,
  Typography,
} from '@mui/material';
import Slide from '@mui/material/Slide';
import { styled, withStyles } from '@mui/styles';
import { CommentType } from 'APIs/BackstageCommentApi';
import BottomIconAvatar from 'components/atoms/Button/BottomIconAvatar';
import HorizontalStatusButton from 'components/atoms/Button/HorizontalStatuButton';
import CardCommentListsWithData from './CardCommentListMobile';
import { selectOtr } from 'features/auth/otrSlice';
import { selectAuth } from 'features/auth/authSlice';

import { OtrData } from 'interfaces/OtrData.interface';

import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import DownloadMenu from './../../../components/organisms/VideoCard/Menu';
import { useAppSelector } from 'app/hooks';
import OtrCommentInput from 'components/atoms/Inputs/OtrCommentInput';

const Transition = React.forwardRef(function Transition(props, ref) {
  // @ts-ignore:next-line
  return <Slide direction="up" ref={ref} {...props} />;
});

const CustomDialog = withStyles(theme => ({
  root: {
    height: '70%',
    '& .MuiBackdrop-root': {
      backgroundColor: 'rgb(255 255 255 / 50%)',
    },
    '& .MuiPaper-root': {
      borderRadius: '20px',
      backgroundColor: '#292739',
    },
  },
}))(Dialog);

const LightChip = styled(Chip)(({ theme }) => ({
  backgroundColor: '#ddb930',
  color: '#fff',
  width: '100px',
}));

interface VideoSidebarProps {
  className: string;
  data: OtrData;
  toggleLike: () => void;
  isLiked: boolean;
  autoScroll: boolean;
  setAutoScroll: React.SetStateAction<any>;
  otrIndex: number;
}

function VideoSidebar({
  className,
  data,
  toggleLike,
  isLiked,
  autoScroll,
  setAutoScroll,
  otrIndex,
}: VideoSidebarProps) {
  const history = useNavigate();

  const more = require('assets/more.png');
  const dots = require('assets/dots-icon.png');
  const user0 = require('assets/Profile/buku_default_avatar.png');
  const user1 = require('assets/user1.png');
  const musicIcon = require('assets/icons/ic_music.png');
  const [open, setOpen] = React.useState(false);
  const [checked] = React.useState(true);
  
  const handleClickOpen = () => {
    setOpen(true);
  };
  
  const handleClose = () => {
    setOpen(false);
  };
  const otrState = useAppSelector(selectOtr);
  const otr = otrState.otrs && otrState.otrs[otrIndex];
  const authState = useAppSelector(selectAuth);

  return (
    <div className={`video__sidebar ${className}`}>
      <Grid container className="topbar">
        
      </Grid>

      <Box className={'layer3'}>
        <Collapse orientation="horizontal" in={checked}>
          <Box className={'layer3__right'}>
            <img
              onClick={() => setAutoScroll(!autoScroll)}
              src={more}
              alt={'img'}
              style={{
                marginTop: '5px',
                width: '30px',
                height: '30px',
                cursor: 'pointer',
              }}
            />
            <Box
              style={{ marginTop: '5px', marginBottom: '5px' }}
              onClick={() => history(`/profile/${data.username}`)}
            >
              <BottomIconAvatar />
            </Box>
            <Box
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '5px',
              }}
            >
              <div onClick={toggleLike}>
                
                {otrState.otrs ? (
                  authState.id &&
                  otrState.otrs[otrIndex] &&
                  otrState.otrs[otrIndex].likes.includes(authState.id) ? (
                    <HorizontalStatusButton
                      type={'favor-filled'}
                      text={`${data.likes.length || 0}`}
                    />
                  ) : (
                    <HorizontalStatusButton
                      type={'favor'}
                      text={`${data.likes.length || 0}`}
                    />
                  )
                ) : (
                  <></>
                )}
              </div>
              <div onClick={handleClickOpen}>
                <HorizontalStatusButton
                  type={'commit'}
                  text={`${data.comments.length}` || '0'}
                />
              </div>
              <DownloadMenu image={data.src_url}>
                <img
                  src={dots}
                  alt={'img'}
                  style={{ marginTop: '12px', width: '30px', height: '30px' }}
                />
              </DownloadMenu>
            </Box>
          </Box>
        </Collapse>
      </Box>

      <Grid container className="bottombar">
        <Grid item xs={6}>
          <p style={{ margin: '0px 0px 5px 5px' }}>Creator</p>
          <LightChip
            avatar={
              <Avatar alt={data.user.username} src={data.user.avatar || user0} />
            }
            label={'@' + data.user.username}
            style={{ background: '#DDB930', color: 'white', fontWeight: '800' }}
          />
        </Grid>
        <Grid item xs={6} style={{ textAlign: 'right' }}>
          <p style={{ margin: '0px 5px 5px 0px' }}>Collector</p>
          <LightChip
            avatar={
              <Avatar alt={data.user.username} src={data.user.avatar || user1} />
            }
            label={'@' + data.user.username}
            style={{ background: '#292739', color: 'white' }}
          />
        </Grid>

        <Grid item xs={8} style={{ marginTop: '.5rem' }}>
          <p style={{ margin: '0px', fontSize: '1rem' }}>{data.description}</p>
        </Grid>
        <Grid
          item
          xs={4}
          style={{
            marginTop: '.5rem',
            textAlign: 'right',
          }}
        >
          <div className="views-button">
            <PlayArrow />{' '}
            <label className="views-button-text">{data.views}</label>
          </div>
        </Grid>

        <Grid
          item
          xs={12}
          style={{ margin: '0', display: 'flex', alignItems: 'center' }}
        >
          <img
            src={musicIcon}
            alt="musicIcon"
            style={{ width: '15px', height: '15px', marginRight: '10px' }}
          />{' '}
          <label>{data.title}</label>
        </Grid>
      </Grid>

      <CustomDialog
        fullScreen
        open={open}
        onClose={handleClose}
        // @ts-ignore:next-line
        TransitionComponent={Transition}
        style={{ top: '30%', left: '0px' }}
      >
        <Box
          style={{
            position: 'relative',
            height: 'fit-content',
            top: 'calc({sheight} - 30px)',
            left: '0px',
          }}
        >
          <Box className={'dialog__header__section'}>
            <Box className={'comment__header__section'}>
              <Typography className={'text_head'}>
                {data.comments.length} comments
              </Typography>
            </Box>
            <CloseIcon className={'text_head_close'} onClick={handleClose} />
          </Box>
          
          <Box className={'comment__section'}>
            {data.comments ? (
              data.comments
                .filter(item => !item.parent)
                .map((item, index) => {
                  return (
                    <CardCommentListsWithData
                      data={item}
                      key={item.id}
                      type={CommentType.NFT}
                    />
                  );
                })
            ) : (
              <></>
            )}
          </Box>
          <Box className={'chart__section'}>
            {otr && (
              <OtrCommentInput
                ownerId={otr.user.id}
                postId={`${otr.id}`}
                type={CommentType.OTR}
                otr={otr}
              />
            )}
          </Box>
        </Box>
      </CustomDialog>
    </div>
  );
}

export default VideoSidebar;
